import Breadcrumbs from "../components/Breadcrumbs";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-14" data-testid="terms-page">
      <Breadcrumbs items={[{ label: "Terms" }]} />
      <h1 className="font-playfair text-4xl sm:text-5xl text-neutral-900 tracking-tight leading-[1.05] mb-6">
        Terms of Use
      </h1>
      <div className="editorial-prose">
        <p>
          These Terms of Use ("Terms") govern your use of SaaSRadarHub. By
          accessing or using the site, you agree to be bound by these Terms.
          This is a general placeholder that should be reviewed and
          customized before relying on it for production use.
        </p>
        <h2>Editorial content</h2>
        <p>
          Content on SaaSRadarHub is published for informational purposes only
          and does not constitute professional, financial, or legal advice.
        </p>
        <h2>Affiliate links</h2>
        <p>
          Some articles contain affiliate links. See our affiliate
          disclosure for more information.
        </p>
        <h2>Changes</h2>
        <p>
          We may update these Terms periodically. Material changes will be
          reflected on this page with an updated effective date.
        </p>
      </div>
    </div>
  );
}
